import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import router from '@/router'

import global from '@/store/modules/Global/global'
import style from '@/store/modules/Style/style'
import configuration from '@/store/modules/Configuration/configuration'
import user from '@/store/modules/User/user'

Vue.use(Vuex)
const state = {
  router: router,
}

export default new Vuex.Store({
  state,
  plugins: [
    createPersistedState({
      key: 'siguetuclub',
      paths: ['global', 'configuration'],
    }),
  ],
  modules: {
    global,
    style,
    configuration,
    user,
  },
})
